import { render, staticRenderFns } from "./reviewsCard.vue?vue&type=template&id=21742b1c&scoped=true"
import script from "./reviewsCard.vue?vue&type=script&lang=js"
export * from "./reviewsCard.vue?vue&type=script&lang=js"
import style0 from "./reviewsCard.vue?vue&type=style&index=0&id=21742b1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21742b1c",
  null
  
)

export default component.exports